var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuBurgerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.88,
    height: 25.612,
    viewBox: "0 0 29.88 25.612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bars-solid",
    d: "M0,66.134A2.132,2.132,0,0,1,2.134,64H27.746a2.134,2.134,0,1,1,0,4.269H2.134A2.132,2.132,0,0,1,0,66.134ZM0,76.806a2.132,2.132,0,0,1,2.134-2.134H27.746a2.134,2.134,0,0,1,0,4.269H2.134A2.132,2.132,0,0,1,0,76.806ZM29.88,87.477a2.132,2.132,0,0,1-2.134,2.134H2.134a2.134,2.134,0,0,1,0-4.269H27.746A2.132,2.132,0,0,1,29.88,87.477Z",
    transform: "translate(0 -64)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBurgerIcon);
export default __webpack_public_path__ + "static/media/menu-burger-icon.a655e86a39f1f6fc49845b2dfc74e8c2.svg";
export { ForwardRef as ReactComponent };